export default {
    //ProductList
    your_created_projects: "Tus cursos creados",
    new_project: "Nuevo Curso",
    projects_name: "NOMBRE DEL CURSO",
    update_at: 'Actualizado el ',
    coming_soon: 'Próximamente',
    search_your_project: 'Busca tu curso...',
    project_name: 'Nombre del curso',
    loading_products: 'Cargando productos...',

    //ProductEditComponent
    modify_project: 'Modificando tu producto',
    general: 'General',
    branding: 'Branding',
    product_page: 'Página de Producto',
    sale: 'Venta',
    seo_text: 'SEO',
    projects: 'Proyectos',

    //CategoriesSlideOverComponent
    categories: 'Categorías',
    text_category: 'Clasifica tus productos por categorías, así facilitarás a tus alumnos comprar tus cursos.',
    select_category: 'Selecciona categoría...',
    ebook: 'E-book',
    online_project: 'Curso online',
    blended_learning: 'Curso semi-presencial',
    online_program: 'Programa Online',
    webinar_consulting: 'Webinar / Consultoría online',
    remove_category: 'Eliminar categoría',
    href_help: 'Deseo saber más sobre las categorías',

    //ProductEdit
    //CustomCategoriesComponent
    //GeneralComponent
    category: 'Categoría',
    duration: 'Duración',
    featured_product: 'Producto destacado',
    delete_project: 'Borrar Curso',
    warning_delete: '¡Atención!',
    message_delete_project: 'Al eliminar el curso perderás todos sus datos definitivamente.',
    question_delete_project: '¿Seguro que quieres eliminar este curso?',
    delete: 'Eliminar',
    confirmation_delete_project: '(*) Esta casilla es obligatoria para eliminar el curso',
    //PageComponent
    principal_page: 'Página principal',
    objectives_presentation: 'Presentación y objetivos',
    learning_objectives: 'No te olvides de describir brevemente los objetivos de aprendizaje.',
    teaching_staff: 'Metodología y profesorado',
    public: 'Público',
    content: 'Contenido',
    sidebar: 'Barra Lateral',
    //ProductBrandingComponent
    banner: 'Banner',
    upload_banner: 'Sube tu banner',
    banner_format: 'PNG, JPG, GIF hasta 3MB',
    promotional_video: 'Video Promocional',
    video_url: 'URL del video',
    video_info: 'Si tienes un video promocional, coloca aquí la url del video en Youtube o Vimeo.',
    //SellComponent
    price_management: 'Gestión de Precios',
    sell_price: 'Precio de venta',
    tax: 'En €. (-3% tasas)',
    price_offer: 'Precio de Oferta',
    text_configuration: 'Configuración de textos',
    free_text_button: 'Título de botón de compra gratuito',
    text_if_free: 'Este título aparecerá si tu producto es gratuito',
    on_sale: 'En venta',
    sale_info: 'Si está activado tu producto estará a la venta',

    //SeoComponent
    seo_configuration: 'Configuración SEO',
    seo_title: 'Título SEO',
    slug: 'Slug',
    seo_description: 'Descripción SEO',

    //ProductListComponent
    featured: 'Destacado',
    classroom: 'Aula',
    slug_text: 'slug',
    product: 'producto',
    products: 'productos',
    preview: 'Previsualizar',

    //AttachProjectSlideOverComponent
    attach_project: 'Asociar Proyecto',
    loading_projects: 'Cargando proyectos asociados...',
    project_selected: 'Proyecto seleccionado',
    quest_attach_project: '¿Quieres adjuntar este proyecto?',
    back: 'Volver',
    add_project: 'Adjuntar Proyecto',
    close_panel: 'Cerrar panel',

    //ProjectAttachedListComponent
    attached_projects: 'Proyectos Asociados',
    loading_products_attached: 'Cargando productos asociados...',
    unattach_project: 'Desasociar proyecto',
    info_unattach_project: 'Al desasociar el proyecto al producto, los alumnos que compren dicho producto no podrán acceder al proyecto.',
    quest_unattach_project: '¿Seguro que quieres desasociar el proyecto ',

    // ProductList · paginación y estados
    search_label: 'Buscar cursos',
    actions: 'Acciones',
    edit_product: 'Editar curso',
    load_error: 'No se han podido cargar los cursos.',
    retry: 'Reintentar',
    no_results_title: 'No hay cursos que coincidan con «{search}»',
    no_results_text: 'Prueba con otro nombre o revisa la ortografía.',
    clear_search: 'Borrar búsqueda',
    empty_title: 'Todavía no has creado ningún curso',
    empty_text: 'Crea tu primer curso para empezar a venderlo en tu academia.',
    product_published: 'Se ha publicado el curso',
    product_unpublished: 'Se ha despublicado el curso',
    unexpected_error: 'Ha ocurrido un error inesperado',

    // TipTapEditorComponent · menú de bloques (página de producto)
    blocks_menu: 'Bloques',
    blocks_menu_label: 'Insertar bloque prediseñado',
    block_badge: 'Aviso destacado',
    block_key_facts: 'Datos clave',
    block_separator: 'Separador',
    block_price_enroll: 'Precio e inscripción',

    // BlockControls · controles de cada bloque
    block_move_up: 'Subir «{block}»',
    block_move_down: 'Bajar «{block}»',
    block_remove: 'Quitar «{block}»',
    block_remove_confirm_title: '¿Quitar este bloque?',
    block_remove_confirm_text: 'El bloque desaparecerá del texto. Puedes recuperarlo con Deshacer (Ctrl+Z) mientras no guardes.',
    block_remove_confirm_action: 'Quitar',

    // PriceEnrollNodeView · bloque «Precio e inscripción»
    price_enroll_price: 'Precio o texto',
    price_enroll_price_placeholder: 'Ej.: 1.200 € / Bonificado / Gratis',
    price_enroll_button_text: 'Texto del botón',
    price_enroll_button_url: 'Enlace del botón',
    price_enroll_note: 'Nota (opcional)',
    price_enroll_button_color: 'Color del botón',
    price_enroll_url_invalid: 'Introduce un enlace que empiece por https://, http:// o mailto:',
    price_enroll_no_button: 'Sin un enlace válido, el botón no se mostrará en la página pública.',
    price_enroll_default_button: 'Inscríbete',

    // InfoPricesNodeView · bloque «Tarifas informativas»
    block_info_prices: 'Tarifas informativas',
    info_prices_title: 'Título (opcional)',
    info_prices_title_placeholder: 'Ej.: Módulo de Inspección de Trabajo',
    info_prices_row: 'Fila {n}',
    info_prices_row_label: 'Etiqueta',
    info_prices_row_label_placeholder: 'Ej.: Colegiados',
    info_prices_row_amount: 'Importe',
    info_prices_row_amount_placeholder: 'Ej.: 360 € / Bonificado',
    info_prices_add_row: 'Añadir fila',
    info_prices_remove_row: 'Quitar fila {n}',
    info_prices_accent_color: 'Color de la primera fila',
    info_prices_default_row_1: 'Tarifa general',
    info_prices_default_row_2: 'Tarifa reducida',

    // LinkButtonNodeView · bloque «Botón de enlace»
    block_link_button: 'Botón de enlace',
    link_button_default_text: 'Más información',
    link_button_text: 'Texto del botón',
    link_button_url: 'Enlace',
    link_button_url_invalid: 'Introduce un enlace que empiece por https://, http:// o mailto:',
    link_button_no_link: 'Sin enlace válido no se muestra el botón. Añade un enlace que empiece por https://, http:// o mailto:',
    link_button_color: 'Color del botón',
    link_button_variant: 'Estilo',
    link_button_variant_solid: 'Relleno',
    link_button_variant_outline: 'Contorno',

    // TipTapEditorComponent · barra de herramientas (FE-054)
    editor_toolbar: 'Formato de texto',
    editor_bold: 'Negrita',
    editor_italic: 'Cursiva',
    editor_underline: 'Subrayado',
    editor_strike: 'Tachado',
    editor_heading_2: 'Título 2',
    editor_heading_3: 'Título 3',
    editor_heading_4: 'Título 4',
    editor_bullet_list: 'Lista con viñetas',
    editor_ordered_list: 'Lista numerada',
    editor_align_left: 'Alinear a la izquierda',
    editor_align_center: 'Centrar',
    editor_align_right: 'Alinear a la derecha',
    editor_blockquote: 'Cita',
    editor_code_block: 'Bloque de código',
    editor_link: 'Enlace',
    editor_remove_link: 'Quitar enlace',
    editor_insert_image: 'Insertar imagen',
    editor_horizontal_rule: 'Línea horizontal',
    editor_text_color: 'Color del texto',
    editor_remove_color: 'Quitar color',
    editor_undo: 'Deshacer',
    editor_redo: 'Rehacer',
    editor_edit_html: 'Editar HTML',
    editor_insert_badge: 'Insertar aviso destacado',
    editor_insert_icon_list: 'Insertar lista con iconos',
    editor_insert_raw_html: 'Insertar HTML personalizado (sin restricciones)',
    editor_badge_panel: 'Aviso destacado:',
    editor_badge_border: 'Borde',
    editor_badge_text: 'Texto',
    editor_badge_background: 'Fondo',
    editor_icon_list_panel: 'Lista con iconos:',
    editor_icon_list_color: 'Color del icono',
    editor_link_url: 'URL del enlace:',
    editor_image_url: 'URL de la imagen:',
    editor_apply: 'Aplicar',
    editor_cancel: 'Cancelar',
    editor_html_source: 'Código HTML',
}
